import React from 'react';

export default function Layout({ children }) {
  return <div className="layout-content">{children}</div>;
}
